import { request } from '../gonfalon';
import { redirectToLogin } from '../shared/authRedirect';

import { type CallerIdentityResponse } from './model';

export const checkAuth = () => request<CallerIdentityResponse>('/private/caller-identity');
export const logOut = () => request<{}>({ method: 'DELETE', url: '/private/caller-identity' });
export const logIn = redirectToLogin; // Redirect user to Okta sign in page
